import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/hooks/useData";

export const Process = () => {
  const { content } = useContent();
  const c = content.process;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32" data-testid="process-section">
      <SectionHeading eyebrow={c.eyebrow} title={c.title} accent={c.accent} description={c.description} />
      <div className="mt-16 border-t border-[#ECEAE4]">
        {c.steps.map((s, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-b border-[#ECEAE4] items-baseline group hover:bg-[#F6F5F2]/60 transition-colors px-2 -mx-2">
              <span className="md:col-span-2 font-display text-4xl text-[#9E8773]">0{i + 1}</span>
              <h3 className="md:col-span-4 font-display text-2xl sm:text-3xl font-medium text-[#2C2A29]">{s.title}</h3>
              <p className="md:col-span-6 text-[#5E5A54] font-light leading-relaxed text-lg">{s.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
